module.exports = __webpack_public_path__ + "7f12ea90a06369734af1e1098a0e6ee9.pdf";